import { createAsyncAction } from 'typesafe-actions';
import * as types from './courses.actionTypes';
import { SingleCourse } from './type';
export const fetchLmsCourses = createAsyncAction(
	types.FETCH_LMS_COURSES_REQUEST,
	types.FETCH_LMS_COURSES_SUCCESS,
	types.FETCH_LMS_COURSES_FAILURE,
)<undefined, SingleCourse[], string>();
